// Profile-menu navigation can be deferred by the mounted mailbox without
// persisting drafts or putting message contents into global state/storage.
export function requestMailNavigation(proceed){
 const event=new window.CustomEvent('career:mail-navigation',{cancelable:true,detail:{proceed}});
 if(window.dispatchEvent(event))proceed();
}
